import { Alert } from '@mui/material';
import { translations } from 'locales/i18n';
import { useTranslation } from 'react-i18next';

export const UnauthorizedPage = () => {
  const { t } = useTranslation();
  return (
    <Alert severity="warning">
      {t(translations.ErrorMessage.AuthError.UNAUTHORIZED)}
    </Alert>
  );
};
